module.exports = __webpack_public_path__ + "img/md-person.d5374614.svg";